/* eslint-disable func-names, prefer-template */
/* globals debounce */

window.DocPopup = {
  setup() {
    let animateScrollTop;
    const $apiReferenceContainer = $('[data-js-api-reference-section]');
    const $docsContainer = $('[data-js-docs-article-content]');
    const $sidebarContainer = $('[data-stickysidebar]');
    this.popupUp = undefined;
    this.popupDown = undefined;
    this.popupUpActive = false;
    this.popupDownActive = false;
    const headerHeight = 96;
    let loadRun = true;
    let lastScrollTop = 0;
    const delayTime = 1000;
    let apiDistanceFromTop;
    let apiUpEdge;

    $('body').on('rendered', function () {
      // Make sure all DOM manipulations had finish
      if ($apiReferenceContainer.length) {
        const $popupDown = $('[data-js-docs-popup-api]');
        const $popupUp = $('[data-js-docs-popup-doc]');
        this.popupUp = $popupUp;
        this.popupDown = $popupDown;

        // Make sure new DOM is loaded when changing languages
        setTimeout(function () {
          apiDistanceFromTop = $apiReferenceContainer.offset().top;
          apiUpEdge = apiDistanceFromTop - $('[data-js-api-doc-separator]').outerHeight() - $(window).height();

          if ($docsContainer.height() < $sidebarContainer.height()) {
            $popupDown.addClass('visible');
            this.popupDownActive = true;
          }
          $(window).scroll(function () {
            if (loadRun) {
              loadRun = false;
              return;
            }

            const scrollTop = $(this).scrollTop();
            const isNearBottom = scrollTop + $(window).height() > $(document).height() - 220;

            // DOC popup
            if (
              scrollTop > apiDistanceFromTop - headerHeight &&
              scrollTop > lastScrollTop &&
              !this.popupUpActive &&
              !isNearBottom
            ) {
              this.popupUpActive = true;
              $popupUp.addClass('visible');
            } else if ((scrollTop <= apiDistanceFromTop - headerHeight && this.popupUpActive) || isNearBottom) {
              this.popupUpActive = false;
              $popupUp.removeClass('visible');
            }

            // API popup
            if (scrollTop < apiUpEdge && scrollTop < lastScrollTop && !this.popupDownActive) {
              $popupDown.addClass('visible');
              this.popupDownActive = true;
            } else if (scrollTop >= apiUpEdge && this.popupDownActive) {
              $popupDown.removeClass('visible');
              this.popupDownActive = false;
            }

            lastScrollTop = scrollTop;
          });

          // Fires when user stops scrolling
          $(window).scroll(
            debounce(
              () =>
                // It only starts to slide up after the delayTime
                setTimeout(function () {
                  if (this.popupUpActive) {
                    $popupUp.removeClass('visible');
                    this.popupUpActive = false;
                  }
                  if (this.popupDownActive) {
                    $popupDown.removeClass('visible');
                    this.popupDownActive = false;
                  }
                }, delayTime),
              delayTime,
            ),
          );

          $popupDown.on('click', function () {
            animateScrollTop($(this), apiDistanceFromTop - headerHeight);
          });

          $popupUp.on('click', function () {
            animateScrollTop($(this), 0);
          });
        }, 300);
      }
    });

    animateScrollTop = function (popup, top) {
      $('html, body').stop(true, false).animate({ scrollTop: top }, 1000);
      popup.removeClass('visible');
      return false;
    };
  },
};
